import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getManageNoticeData = params =>
  axios.get(`${API_HOST}/manageNotices`, { params, withCredentials: true });

export const editManageNoticeReadData = (manageAccountId, params) =>
  axios.put(`${API_HOST}/manageNotices/reads/${manageAccountId}`, params, {
    withCredentials: true
  });
